module.exports = __webpack_public_path__ + "static/img/ent-detail-29.52006bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-29.jpg
// module id = ay7T
// module chunks = 52